import { mixin } from '../helpers/mixins';
import { backgroundColor } from '../style/background-color';
export const backgroundColorMixin = mixin(backgroundColor, ['backgroundColor', '$backgroundColor', 'bg', '$bg']);
export const backgroundColorKeys = ['backgroundColor', 'bg'];